<template>
  <VueDragResize class="poll" ref="container" :parentLimitation="false" :z="z" :x="left" :y="topRef" :isResizable="false" @dragging="dragging" @dragstop="dragstop" @clicked="updateZ" :style="{opacity:opacity}">
    <h3 v-show="!showResults" class="box-title" v-html="title"></h3>
    <h3 v-show="showResults" class="box-title" v-html="resultsTitle"></h3>
    <a class="poll-close-button" href="#" @click.prevent="hidePoll()" @touchstart="hidePoll()">X</a>
    <div class="interactivity-contents" v-if="currentPoll">
      <div class="question-container" ref="poll-question">
        <div class="question" v-html="currentQuestion"></div>
      </div>
      <div class="box-answers" :style="{opacity:!showResults || currentPoll.interacted==index ?'1':'0.5'}" v-for="(option, index) in options" :key="index" v-show="option.fixed && currentPoll && !currentPoll.type.ratings">
        <a href="#" @click.prevent="sendAnswer(index)" @touchstart="sendAnswer(index)" :style="{cursor:showResults?'grab':'pointer'}">
          <div class="answerContainer">
          <div class="answer" >{{ option.title }}</div>
            <div v-show="showResults && typeShowResults" class="option-score">{{ option.score.toFixed(0) }}%
            </div> 
          </div>
        </a>
      </div>
    </div>
    <StarsRating style="margin: 0 10px" :totalStars="options.length" :interacted="parseInt(currentPoll.interacted)" :globalRating="ratingComputed" :isIndicatorActive="true" :typeShowResults="typeShowResults" :showResults="showResults" :starStyle="starStyle" @clicked="pollRated" v-if="currentPoll && currentPoll.type.ratings && options.length" />
  </VueDragResize>
</template>
<script>
import VueDragResize from 'vue-drag-resize';
import StarsRating from '@/components/external_interactions/StarsRating.vue';

export default {
  name: 'Poll',
  components: {
    VueDragResize,
    StarsRating,
  },
  props: {
    currentPoll: Object,
    title: String,
    resultsTitle: String,
    rawData: Object,
    configShowResults: Boolean,
    isVideoFullscreen: Boolean,
    isMobile: Boolean,
    z: Number,
    topRef: Number,
    leftRef: Number,
    config: {
      type: Object,
    },
  },
  data() {
    return {
      poll_id: null,
      showTitle: true,
      showQuestion: true,
      showResults: false,
      currentQuestion: '',
      options: [],
      finished: false,
      width: 0,
      height: 0,
      top: 200,
      left: 70,
      counter: 0,
      isDragging: false,
      starStyle: {
        fullStarColor: '#ed8a19',
        emptyStarColor: '#737373',
        indicatorColor: '#FFFFFF',
        starWidth: 40,
        starHeight: 40,
      },
    };
  },

  methods: {
    hidePoll() {
      this.$emit('hidePoll');
    },
    beginPoll(pollData) {
      this.poll_id = pollData.poll_id;
      this.currentQuestion = pollData.question;

      this.options = [];
      for (let i = 0; i < pollData.options.length; i++) {
        this.options.push({
          title: pollData.options[i].title,
          score: 0,
          fixed: true,
        });
      }
      let marker = `${this.$store.state.user.id}-${pollData.poll_id}`;
      if (this.$store.state.markers.answeredPolls.includes(marker)) {
        this.showResults = this.typeShowResults;
        if (!this.typeShowResults) {
          this.options.map(opt => (opt.fixed = false));
          this.currentQuestion = this.currentQuestion + '<br><p style="margin-top:10px;opacity:0.8"> Sua resposta já foi computada.<br> Obrigado!</p>';
        }
        this.finished = true;
      } else {
        this.showResults = false;
        this.finished = false;
      }
    },
    sendAnswer(value) {
      if (this.isDragging) return;
      if (this.finished) return;

      this.finished = true;
      this.$emit('finished', {
        id: this.poll_id,
        answer: value,
      });

      if (!this.typeShowResults) {
        this.options.map((opt, i) => {
          if (value != i) opt.fixed = false;
          return opt;
        });
      }

      this.showResults = true;
    },
    updatePoll(values, total) {
      //console.log('updatePoll', values, total);
      for (let i = 0; i < values.length; i++) {
        this.options[i].score = (values[i] / total) * 100;
      }
    },
    dragging(newRect) {
      this.isDragging = true;
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    dragstop() {
      this.isDragging = false;
    },
    updateZ() {
      this.counter++;
      if (this.counter > 1) {
        this.counter = 1;
        this.$emit('bringToFront', 'poll');
      }
    },
    pollRated(value) {
      this.sendAnswer(value);
    },
  },
  computed: {
    typeShowResults() {
      if (this.currentPoll?.type?.showResults) return this.currentPoll.type.showResults;
      else return false;
    },
    topComputed() {
      return this.topRef;
    },
    leftComputed() {
      return this.leftRef + 10;
    },
    opacity() {
      return this.z == 2 ? 1 : 0.7;
    },
    totalVotes() {
      return this.rawData.answers.reduce((acc, vote) => acc + vote, 0);
    },
    ratingComputed() {
      return this.totalVotes ? this.rawData.answers.reduce((acc, vote, index) => acc + vote * (index + 1), 0) / this.totalVotes : 0;
    },
  },
  beforeMount() {
    this.top = this.topRef;
    this.left = this.leftRef;
    if (this.isMobile) {
      this.top = 80;
      this.left = 50;
    }
  },
};
</script>
<style lang="scss">
</style>